import { useEffect, useState } from 'react';

export default function ConfirmDeleteDialog({ open, onClose, onConfirm, roleName = '' }) {
  const PHRASE = 'CONFIRMAR';
  const [typed, setTyped] = useState('');
  const [enabled, setEnabled] = useState(false);

  useEffect(() => { setEnabled(typed.trim() === PHRASE); }, [typed]);

  if (!open) return null;

  return (
    <div className="roles-confirm-overlay" role="dialog" aria-modal="true">
      <div className="roles-confirm-card">
        <div className="roles-confirm-title">Eliminar</div>
        <div className="roles-confirm-sub">
          Estás a punto de eliminar <strong>{roleName || 'este rol'}</strong>.
        </div>

        <div style={{ marginTop: '0.5rem' }}>
          <div style={{ fontSize: '0.95rem', marginBottom: 6 }}>
            Escribe <code>'{PHRASE}'</code> para eliminarlo permanentemente.
          </div>
          <input
            className="roles-confirm-input"
            placeholder={PHRASE}
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
          />
        </div>

        <div className="roles-confirm-footer">
          <button type="button" className="btn-cancel" onClick={onClose}>Cancelar</button>
          <button
            type="button"
            className="btn-action"
            disabled={!enabled}
            onClick={onConfirm}
          >Eliminar</button>
        </div>
      </div>
    </div>
  );
}